import { useState, useEffect } from "react";
import { HTTPURL } from "../constants/matcher";

const useFetch = (url) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(url)
      .then((res) => res.json())
      .then((data) => setData(data));
  }, [url]);

  return [data];
};

const useFetchMyApi1 = () => {
    const [items1, setItems] = useState([]);
  
    // custom fetch function consumes location
    const locationFetch = (location = "") => {
      // let's stimulate the API call with a 2 seconds response time
      setTimeout(() => setItems([location, Math.random()]), 2000);
    };
    
    return [items1, locationFetch]; // <-- return state and fetch function
};

const useFetchMyApi2 = (location = "") => {
    const [items2, setItems] = useState([]);
    useEffect(() => {
      // let's stimulate the API call with a 2 seconds response time
      setTimeout(() => setItems([location, Math.random()]), 2000);
    }, [location]); // <-- effect callback triggers when location updates
    return { items2 };
};

const useFetchApi = (reqData) => {
    // if(!reqData) return;

    const [resData, setresData] = useState([]);
    
    // const REQUEST_OPTIONS = {
        
    // };

    const REQUEST_OPTIONS = {
        headers: {}
    };

    // if(reqData.head=='head'){
    if(reqData.head && reqData.head=='head'){
        // const REQUEST_OPTIONS = {
        //     headers: { 'Content-Type': 'application/json' },
        // };

        REQUEST_OPTIONS.headers['Content-Type'] = 'application/json';
    }

    if(reqData.type && reqData.type=='post'){
        REQUEST_OPTIONS.method = 'POST';
    }

    if(reqData.token && reqData.token=='required'){
        const token = JSON.parse(localStorage.getItem("user-token"));
        REQUEST_OPTIONS.headers['Authorization'] = `Bearer ${token}`;
    }

    REQUEST_OPTIONS.body = reqData.data;

    useEffect(() => {
        if(Object.keys(reqData).length !== 0){
            console.log("yes request data...");

            fetch(HTTPURL+reqData.link, REQUEST_OPTIONS)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();
    
                if (!response.ok) {
                    const error = (data && data.message) || response.status;
                    return Promise.reject(error);
                }
    
                setresData(data);
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        } 
        else{
            console.log("no request data...");
        }     
    }, [reqData]); // <-- effect callback triggers when reqData updates

    return { resData };
};

// export default useFetch;
export {useFetch, useFetchMyApi1, useFetchMyApi2, useFetchApi};
